module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/card-item/card-item.component.scss
// module id = ./src/app/modules/common-module/components/card-item/card-item.component.scss
// module chunks = 9